import React from 'react';

import {
  BarChartOutlined as DashboardBarIcon,
  BulbOutlined as LampOutlineIcon,
  ControlOutlined as ParametersIcon,
  DashboardOutlined as DashboardRoundOutlineIcon,
  DollarOutlined as MoneyIcon,
  FolderOpenOutlined as FolderOutlineIcon,
  QuestionCircleOutlined as HelpOutlineIcon,
  SettingOutlined as SettingsOutlineIcon,
  ShoppingCartOutlined as CartOutlineIcon
} from '@ant-design/icons';

type RouteNode = {
  to: string;
  label: string;
  permission?: string;
  isUnityExclusive?: boolean;
  betaModule?: string;
  tour?: string;
};

export type Route = {
  to?: string;
  label: string;
  icon?: React.ReactNode;
  nodes?: RouteNode[];
  permission?: string;
  userTypes?: string[];
  isUnityExclusive?: boolean;
  accessPerBelt?: number[];
  betaModule?: string;
  tour?: string;
  external?: boolean;
};

const routes: Route[] = [
  {
    to: '/producer/dashboard',
    label: 'Dashboard',
    icon: <DashboardRoundOutlineIcon style={{ fontSize: 24 }} />
  },
  {
    to: '/producer/shopping',
    label: 'Compras',
    icon: <MoneyIcon style={{ fontSize: 24 }} />,
    userTypes: ['onlyCustomer']
  },
  {
    label: 'Vendas',
    icon: <CartOutlineIcon style={{ fontSize: 24 }} />,
    userTypes: ['producer', 'affiliate'],
    nodes: [
      {
        to: '/producer/sales',
        label: 'Minhas Vendas',
        permission: 'myeduzz:minhas-vendas:visualizar'
      },
      {
        to: '/producer/leads',
        label: 'Meus Leads',
        permission: 'myeduzz:meus-leads:visualizar'
      },
      {
        to: '/producer/myaffiliates',
        label: 'Meus Afiliados',
        permission: 'myeduzz:meus-afiliados:visualizar'
      },
      {
        to: '/producer/orders',
        label: 'Minhas Entregas',
        permission: 'myeduzz:minhas-entregas:visualizar'
      },
      {
        to: '/producer/whitelist',
        label: 'Whitelist',
        permission: 'myeduzz:whitelist:visualizar'
      },
      {
        to: '/producer/request-management',
        label: 'Ações Pendentes',
        permission: 'myeduzz:request-management:visualizar'
      }
    ]
  },
  {
    label: 'Produtos',
    icon: <FolderOutlineIcon style={{ fontSize: 24 }} />,
    userTypes: ['producer', 'affiliate'],
    nodes: [
      {
        to: '/producer/product/myproducts',
        label: 'Meus Produtos',
        permission: 'myeduzz:meus-produtos:visualizar'
      },
      {
        to: '/producer/affiliations',
        label: 'Minhas Afiliações',
        permission: 'myeduzz:meus-afiliados:visualizar'
      },
      {
        to: '/producer/campaigns',
        label: 'Links',
        permission: 'myeduzz:links:visualizar'
      }
    ]
  },
  {
    label: 'Financeiro',
    icon: <MoneyIcon style={{ fontSize: 24 }} />,
    userTypes: ['producer', 'affiliate'],
    nodes: [
      {
        to: '/producer/financial-statement',
        label: 'Extrato',
        permission: 'myeduzz:financeiro:visualizar'
      }
    ]
  },
  {
    to: '/producer/reports/sales',
    label: 'Relatórios',
    icon: <DashboardBarIcon style={{ fontSize: 24 }} />,
    userTypes: ['producer'],
    tour: 'new_sales_reports',
    permission: 'myeduzz:reports:visualizar'
  },
  {
    to: 'https://space.eduzz.com',
    label: 'Soluções',
    icon: <LampOutlineIcon style={{ fontSize: 24 }} />,
    userTypes: ['producer', 'affiliate'],
    permission: 'no-access-control-permission',
    external: true
  },
  {
    label: 'Integrações',
    icon: <SettingsOutlineIcon style={{ fontSize: 24 }} />,
    userTypes: ['producer', 'affiliate'],
    nodes: [
      {
        to: '/producer/config-api',
        label: 'Configurações da API',
        permission: 'no-access-control-permission'
      },
      {
        to: '/producer/cdf',
        label: 'Central de Documentos Fiscais',
        permission: 'myeduzz:cdf:visualizar'
      },
      {
        to: '/producer/connect/myconnects',
        label: 'Connect',
        permission: 'myeduzz:connect:visualizar'
      },
      {
        to: '/producer/new-connect',
        label: 'Novo Connect',
        permission: 'myeduzz:connect:visualizar',
        betaModule: 'new_connect'
      },
      {
        to: '/producer/webhook',
        label: 'Webhooks',
        permission: 'myeduzz:webhook:visualizar'
      }
    ]
  },
  {
    label: 'Configurações',
    icon: <ParametersIcon style={{ fontSize: 24 }} />,
    userTypes: ['producer'],
    nodes: [
      {
        to: '/producer/access',
        label: 'Controle de Acesso',
        permission: 'no-access-control-permission'
      }
    ]
  },
  {
    to: '/producer/help',
    label: 'Ajuda',
    icon: <HelpOutlineIcon style={{ fontSize: 24 }} />,
    permission: 'myeduzz:ajuda:visualizar'
  }
];

export { routes };
